/* Giveaway landing page (sections/giveaway-hero.liquid): page state, countdown,
   form submit and the giveaway_lead event for the Meta custom pixel (O-13).

   States: upcoming → open → ended by the clock (UTC start/end from the section);
   thanks after an entry, confirmed on ?confirmed=1 (double opt-in redirect),
   ended-thanks after the Black Friday early-access signup.
   ?gw_state=<state> forces a state for review; the endpoint still enforces the dates. */
(function () {
  'use strict';

  var hero = document.querySelector('[data-gw-hero]');
  if (!hero) return;

  var config = JSON.parse(hero.querySelector('[data-gw-config]').textContent);
  var start = Date.parse(config.start);
  var end = Date.parse(config.end);
  var params = new URLSearchParams(window.location.search);

  var STATES = ['upcoming', 'open', 'thanks', 'confirmed', 'ended', 'ended-thanks'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  // Most common throwaway domains; the endpoint should check a full list.
  var DISPOSABLE = [
    '10minutemail.com', '10minutemail.net', 'burnermail.io', 'discard.email', 'dispostable.com',
    'emailondeck.com', 'fakeinbox.com', 'getairmail.com', 'getnada.com', 'grr.la', 'guerrillamail.com',
    'guerrillamail.net', 'inboxkitten.com', 'mail.tm', 'mail7.io', 'mailcatch.com', 'maildrop.cc',
    'mailinator.com', 'mailnesia.com', 'mailpoof.com', 'mintemail.com', 'moakt.com', 'mohmal.com',
    'mytemp.email', 'nada.email', 'sharklasers.com', 'spamgourmet.com', 'temp-mail.io', 'temp-mail.org',
    'tempinbox.com', 'tempmail.com', 'tempmail.net', 'tempr.email', 'throwawaymail.com', 'tmpmail.net',
    'tmpmail.org', 'trashmail.com', 'yopmail.com', 'yopmail.net'
  ];

  var utm = readUtm();
  var forced = STATES.indexOf(params.get('gw_state')) !== -1 ? params.get('gw_state') : null;

  setState(forced || (params.get('confirmed') === '1' ? 'confirmed' : phase(Date.now())));
  startCountdown();

  hero.querySelectorAll('[data-gw-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submit(form);
    });
  });

  /* ---------- State ---------- */

  function phase(now) {
    if (now < start) return 'upcoming';
    if (now > end) return 'ended';
    return 'open';
  }

  function setState(state, moveFocus) {
    hero.setAttribute('data-state', state);
    hero.querySelectorAll('[data-gw-show]').forEach(function (el) {
      el.hidden = el.getAttribute('data-gw-show').split(' ').indexOf(state) === -1;
    });
    if (!moveFocus) return;
    var heading = hero.querySelector('[data-gw-show~="' + state + '"] [tabindex="-1"]');
    if (heading) heading.focus({ preventScroll: true });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hero.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Countdown ---------- */

  function startCountdown() {
    var box = hero.querySelector('[data-gw-countdown]');
    if (!box) return;
    var label = box.querySelector('[data-gw-count-label]');
    var out = {
      d: box.querySelector('[data-gw-d]'),
      h: box.querySelector('[data-gw-h]'),
      m: box.querySelector('[data-gw-m]'),
      s: box.querySelector('[data-gw-s]')
    };

    function tick() {
      var now = Date.now();
      var state = hero.getAttribute('data-state');
      // Roll upcoming → open → ended while the visitor is on the page (not after a submit).
      if (!forced && (state === 'upcoming' || state === 'open') && phase(now) !== state) {
        state = phase(now);
        setState(state);
      }
      var left = Math.max(0, Math.floor(((state === 'upcoming' ? start : end) - now) / 1000));
      out.d.textContent = Math.floor(left / 86400);
      out.h.textContent = pad(Math.floor((left % 86400) / 3600));
      out.m.textContent = pad(Math.floor((left % 3600) / 60));
      out.s.textContent = pad(left % 60);
      label.textContent = label.getAttribute(state === 'upcoming' ? 'data-upcoming' : 'data-open');
    }

    tick();
    setInterval(tick, 1000);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* ---------- Form ---------- */

  function submit(form) {
    var intent = form.getAttribute('data-gw-form');
    var button = form.querySelector('button[type="submit"]');
    var emailInput = form.elements.email;
    var nameInput = form.elements.first_name;
    var email = emailInput.value.trim().toLowerCase();
    var firstName = nameInput ? nameInput.value.trim().replace(/\s+/g, ' ') : '';

    clearError(form);
    if (nameInput && !firstName) return showError(form, config.messages.required, nameInput);
    if (!email) return showError(form, config.messages.required, emailInput);
    if (!EMAIL_RE.test(email)) return showError(form, config.messages.email, emailInput);
    if (DISPOSABLE.indexOf(email.split('@')[1]) !== -1) return showError(form, config.messages.disposable, emailInput);

    // Bots fill the hidden field: show success, send nothing.
    if (form.elements.company && form.elements.company.value) return succeed(form, intent, firstName, null);

    var payload = {
      intent: intent,
      email: email,
      first_name: firstName,
      source: 'landing_page',
      utm: utm,
      event_id: eventId(),
      page: window.location.origin + window.location.pathname
    };

    if (config.turnstileSiteKey && intent === 'entry') {
      var token = form.querySelector('[name="cf-turnstile-response"]');
      if (!token || !token.value) return showError(form, config.messages.captcha);
      payload.turnstile_token = token.value;
    }

    button.disabled = true;
    send(payload)
      .then(function () {
        succeed(form, intent, firstName, payload);
      })
      .catch(function (error) {
        showError(form, config.messages[error && error.code] || config.messages.generic);
        resetCaptcha(form);
      })
      .then(function () {
        button.disabled = false;
      });
  }

  function send(payload) {
    if (!config.endpoint) {
      // Without an endpoint the form only "works" in theme preview, so the states can be reviewed.
      if (isPreview()) {
        console.info('[giveaway] No endpoint set; preview only, nothing sent.', payload);
        return new Promise(function (resolve) { setTimeout(resolve, 400); });
      }
      return Promise.reject({ code: 'generic' });
    }
    return fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(
      function (res) {
        if (res.ok) return;
        return res.json()
          .catch(function () { return {}; })
          .then(function (data) { throw { code: data.error }; });
      },
      function () {
        throw { code: 'generic' };
      }
    );
  }

  function succeed(form, intent, firstName, payload) {
    if (intent === 'entry') {
      var heading = hero.querySelector('[data-gw-thanks-heading]');
      var template = heading.getAttribute('data-template');
      heading.textContent = firstName
        ? template.replace('{first_name}', firstName)
        : template.replace(/,?\s*\{first_name\}/, '');
      if (payload) {
        publish('giveaway_lead', {
          event_id: payload.event_id,
          source: payload.source,
          utm_source: utm.utm_source || null,
          utm_medium: utm.utm_medium || null,
          utm_campaign: utm.utm_campaign || null
        });
      }
      setState('thanks', true);
    } else {
      setState('ended-thanks', true);
    }
    form.reset();
  }

  function showError(form, message, input) {
    var box = form.querySelector('[data-gw-error]');
    box.textContent = message;
    box.hidden = false;
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
  }

  function clearError(form) {
    form.querySelector('[data-gw-error]').hidden = true;
    form.querySelectorAll('[aria-invalid]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });
  }

  function resetCaptcha(form) {
    var widget = form.querySelector('.cf-turnstile');
    if (widget && window.turnstile) {
      try { window.turnstile.reset(widget); } catch (e) { /* widget not rendered yet */ }
    }
  }

  /* ---------- Helpers ---------- */

  // UTMs from the landing URL, kept for the tab session so in-page navigation doesn't lose them.
  function readUtm() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('gw_utm') || '{}'); } catch (e) { /* storage blocked */ }
    var fresh = {};
    UTM_KEYS.forEach(function (key) {
      if (params.get(key)) fresh[key] = params.get(key).slice(0, 100);
    });
    if (Object.keys(fresh).length) {
      stored = fresh;
      try { sessionStorage.setItem('gw_utm', JSON.stringify(stored)); } catch (e) { /* storage blocked */ }
    }
    return stored;
  }

  // Theme editor or an unpublished theme preview.
  function isPreview() {
    var shopify = window.Shopify || {};
    return Boolean(shopify.designMode || (shopify.theme && shopify.theme.role && shopify.theme.role !== 'main'));
  }

  // Read by the custom pixel in Customer events, which sends Lead to Meta (O-13).
  function publish(name, data) {
    var shopify = window.Shopify;
    try {
      if (shopify && shopify.analytics && shopify.analytics.publish) shopify.analytics.publish(name, data);
    } catch (e) { /* analytics unavailable */ }
  }

  function eventId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
})();
